/* eslint-disable @typescript-eslint/no-unused-vars */
import {
    ConstantNodeExpressionStrategy,
    InputNodeExpressionStrategy,
    OutputNodeExpressionStrategy,
    SimulationNodeExpressionStrategy,
} from './ExpressionStrategies';
import { ExpressionStrategy } from './ExpressionStrategy';
import { GraphNode } from '../../graph/GraphNode';
import { InputType } from '../types/Enum';

export class ExpressionStrategyFactory {
    static isConstant(node: GraphNode & { sourceType?: InputType }): boolean {
        return node.sourceType === InputType.CONSTANT;
    }

    static isOutput(node: GraphNode & { userExpression?: string }): boolean {
        return node.userExpression != undefined;
    }

    static isSimulation(node: GraphNode & { sourceType?: InputType }): boolean {
        return node.sourceType === InputType.SIMULATION;
    }

    public getStrategy(node: GraphNode): ExpressionStrategy {
        if (ExpressionStrategyFactory.isConstant(node)) {
            return new ConstantNodeExpressionStrategy();
        }
        if (ExpressionStrategyFactory.isSimulation(node)) {
            return new SimulationNodeExpressionStrategy();
        }
        if (ExpressionStrategyFactory.isOutput(node)) {
            return new OutputNodeExpressionStrategy();
        }
        return new InputNodeExpressionStrategy();
    }
}
